<template>
  <div class="modal fade show" ref="modalRef" :class="name + '-modal'" :id="name + '-modal'" tabindex="-1" role="dialog" @closed=modalHide v-show="isOpen" style="display:block;">
    <div class="modal-dialog" :class="modalSizeClass">
      <div class="modal-content" v-bind:style=" sgc ? 'text-align:center;overflow:hidden;' : '' ">
        <slot name="modal-header" v-if="sgc">
          <div class="modal-header" style="text-align:center;background-color:lightgray;">
            <h2>
              {{sgc}}
            </h2>
          </div>
        </slot>
        <div class="modal-body">
          <slot></slot>
        </div>
        <div v-if="!disableOk || !disableCancel" class="modal-footer" v-bind:style=" sgc ? 'text-align:center;' : '' ">
          <slot name="modal-footer">
            <button @click="cancelClick" class="btn btn-primary btn-nomargin" type="button" v-if="!disableCancel">
              {{ cancelTitle }}
            </button>
            <slot name="extra-buttons"></slot>
            <button :v-bind="tooltipAttrs" id="name + '-modal-btn'" ref="okBtn" @click="okClick" class="btn btn-primary btn-nomargin" type="button" v-show="!disableOk">
              {{ okTitle }}
            </button>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "bootstrap-modal",
    props: {
      name:           { type: String   },
      okTooltip:      { default: ''    },
      okTitle:        { default: 'Ok'  },
      cancelTitle:    { default: 'Cancel' },
      sgc:            { default: ''  },
      disableOk:      { default: false },
      disableCancel:  { default: false, type: Boolean },
      largeModal:     { default: false, type: Boolean },
      smallModal:     { default: false, type: Boolean },
      value:          { type: Boolean  },
    },
    data() {
      return {
        isOpen: false
      }
    },
    computed: {
      modalSizeClass() {
        if (this.largeModal)
          return 'modal-lg'
        else if (this.smallModal)
          return 'modal-sm'
        else
          return ''
      },
      tooltipAttrs() {
        if (this.okTooltip)
          return {
            'data-bs-toggle': 'tooltip',
            'data-bs-placement': 'top',
            title: this.okTooltip,
          }
        return {}
      }
    },
    methods: {
      cancelClick() {
        this.$emit('cancel')
        this.modalHide()
      },
      okClick() {
        this.$emit('ok')
        this.modalHide()
      },
      modalShow() {
        this.isOpen = true
	$("#" + this.name + "-modal").modal('show')
      },
      modalHide() {
        this.isOpen = false
	$("#" + this.name + "-modal").modal('hide')
      },
    },
    watch: {
      value(val) {
	console.log("watch - bs_modal")
        if (val) {
          this.modalShow()
        } else {
          this.modalHide()
        }
      },
      isOpen(val) {
        if (val) {
	  $("." + this.name + "-modal").modal('show')
        } else {
	  $("." + this.name + "-modal").modal('hide')
        }
      }

    },
    mounted() {
      this.isOpen = this.value
      window.jQuery(this.$el).on('hide.bs.modal', () => {
	console.log("bs_modal on hide")
        this.$emit('input', false)
        var leg=$('.videoPlayer').attr("src");
        $('.videoPlayer').attr("src",leg);
        if (this.isOpen) {
          this.$emit('cancel')
          this.isOpen = false
        }
      })

      //if (this.okTooltip)
        //window.jQuery(this.$refs.okBtn)?.tooltip()
    }
  }
</script>
